import { Controller } from "@hotwired/stimulus"

export default class FormHintController extends Controller {
  formatPhone(event: Event) {
    const input = event.target as HTMLInputElement
    const raw = input.value

    // International number — starts with +, allow digits/spaces/hyphens/parens freely
    if (raw.startsWith("+")) {
      input.value = "+" + raw.slice(1).replace(/[^\d\s\-().]/g, "")
      return
    }

    // Brazilian number formatting
    let value = raw.replace(/\D/g, "")

    if (value.length <= 2) {
      value = `(${value}`
    } else if (value.length <= 7) {
      value = `(${value.slice(0, 2)}) ${value.slice(2)}`
    } else if (value.length <= 11) {
      const mid = value.length > 10 ? 7 : 6
      value = `(${value.slice(0, 2)}) ${value.slice(2, mid)}-${value.slice(mid)}`
    } else {
      value = `(${value.slice(0, 2)}) ${value.slice(2, 7)}-${value.slice(7, 11)}`
    }

    input.value = value
  }
}
